{
  "longPressMessage": "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
}
